export default "__VITE_ASSET__saUhZUjm__"